module.exports = (__parcel__import__("5L8Lp")).then(() => parcelRequire('4MKVl'));